import { Badge } from '@/components/ui/badge'

import { OrderStatus, ShippingStatus } from './types'

// Get status badge with colors
export const getStatusBadge = (status: OrderStatus) => {
  let label: string
  let className: string

  switch (status) {
    case OrderStatus.PENDING:
      label = 'รอชำระเงิน'
      className = 'bg-yellow-500 text-white'
      break
    case OrderStatus.PAYMENT:
      label = 'ชำระเงินแล้ว'
      className = 'bg-orange-500 text-white'
      break
    case OrderStatus.COMPLETED:
      label = 'สำเร็จ'
      className = 'bg-green-500 text-white'
      break
    case OrderStatus.CANCEL:
      label = 'ยกเลิก'
      className = 'bg-red-500 text-white'
      break
    case OrderStatus.ALL:
      label = 'ทั้งหมด'
      className = 'bg-gray-300 text-black'
      break
    default:
      label = 'รอชำระเงิน'
      className = 'bg-yellow-500 text-white'
      break
  }

  return <Badge className={className}>{label}</Badge>
}

// Get shipping status badge
export const getShippingStatusBadge = (status: ShippingStatus) => {
  let label: string
  let className: string

  switch (status) {
    case ShippingStatus.DELIVERED:
      label = 'จัดส่งสำเร็จ'
      className = 'bg-green-500 text-white'
      break
    case ShippingStatus.SHIPPED:
      label = 'จัดส่งแล้ว'
      className = 'bg-purple-500 text-white'
      break
    case ShippingStatus.CANCELLED:
      label = 'ยกเลิก'
      className = 'bg-red-500 text-white'
      break
    case ShippingStatus.ALL:
      label = 'ทั้งหมด'
      className = 'bg-gray-300 text-black'
      break
    default:
      label = 'รอจัดส่ง'
      className = 'bg-yellow-500 text-white'
      break
  }

  return <Badge className={className}>{label}</Badge>
}

// Shipping status options for the select dropdown
export interface OptionType {
  value: OrderStatus | ShippingStatus
  label: string
}

export const orderStatusOptions: OptionType[] = [
  { value: OrderStatus.PENDING, label: 'รอชำระเงิน' },
  { value: OrderStatus.PAYMENT, label: 'ชำระเงินแล้ว' },
  { value: OrderStatus.COMPLETED, label: 'ยืนยันการชำระเงิน' },
  { value: OrderStatus.CANCEL, label: 'ยกเลิก' },
]

export const shippingStatusOptions: OptionType[] = [
  { value: ShippingStatus.PENDING, label: 'รอจัดส่ง' },
  { value: ShippingStatus.SHIPPED, label: 'จัดส่งแล้ว' },
  { value: ShippingStatus.DELIVERED, label: 'จัดส่งสำเร็จ' },
  { value: ShippingStatus.CANCELLED, label: 'ยกเลิก' },
]
